import { Dumbbell, Footprints, MapPin } from 'lucide-react';
import React from 'react';
import { observer } from 'mobx-react';
import { Button } from '@components/ui/button';
import { AddSteps } from './add-steps';
import { AddWorkout } from './add-workout';
import { AddFacilityVisit } from './add-facility-visit';

interface AddActivityProps {
    onChange?: () => void;
}

export const AddActivity = observer(({ onChange }: AddActivityProps) => {
    const [addStepsModalOpen, setAddStepsModalOpen] =
        React.useState<boolean>(false);
    const [addWorkoutModalOpen, setAddWorkoutModalOpen] =
        React.useState<boolean>(false);
    const [addFacilityVisitModalOpen, setAddFacilityVisitModalOpen] =
        React.useState<boolean>(false);

    return (
        <>
            <div className="mb-4 flex flex-wrap justify-end gap-2">
                <Button
                    variant="outline"
                    onClick={() => setAddStepsModalOpen(true)}
                >
                    <Footprints />
                    Add Steps
                </Button>
                <Button
                    variant="outline"
                    onClick={() => setAddWorkoutModalOpen(true)}
                >
                    <Dumbbell />
                    Add workout
                </Button>
                <Button
                    variant="outline"
                    onClick={() => setAddFacilityVisitModalOpen(true)}
                >
                    <MapPin />
                    Add facility visit
                </Button>
            </div>

            <AddSteps
                open={addStepsModalOpen}
                onModalClose={() => setAddStepsModalOpen(false)}
                onSuccess={onChange}
            />

            <AddWorkout
                open={addWorkoutModalOpen}
                onModalClose={() => setAddWorkoutModalOpen(false)}
                onSuccess={onChange}
            />

            <AddFacilityVisit
                open={addFacilityVisitModalOpen}
                onModalClose={() => setAddFacilityVisitModalOpen(false)}
                onSuccess={onChange}
            />
        </>
    );
});
